// Verify Amplitude script is loaded
const isAmplitudeLoaded = () =>
  typeof window !== "undefined" &&
  window.amplitude &&
  window.amplitude.setUserId;

// ============================================================================
// User Profile
// ============================================================================

// Set user ID to unify multiple-session-data for the same user
const setUserId = (userId) => {
  if (isAmplitudeLoaded()) {
    window.amplitude.setUserId(userId);
  };
};

const setUserProperties = (props) => {
  if (isAmplitudeLoaded()) {
    window.amplitude.setUserProperties(props);
  };
};

// Reset Amplitude user profile——used when signing out
const reset = () => {
  if (isAmplitudeLoaded()) {
    window.amplitude.reset();
  };
};

// ============================================================================
// Events Tracking -- see `docs/analytics.md`
// ============================================================================

const track = (event, props = {}) => {
  if (isAmplitudeLoaded()) {
    window.amplitude.track(event, props);
  };
};

const trackClickedSignIn = (entryPoint) => {
  track("Clicked Sign In", { entryPoint });
};

const trackSignedIn = (method) => {
  track("Signed In", { method });
};

const trackSignedUp = (method) => {
  track("Signed Up", { method });
};

// ============================================================================
// Exports
// ============================================================================

export {
  reset,
  setUserId,
  setUserProperties,
  track,
  trackClickedSignIn,
  trackSignedIn,
  trackSignedUp,
};
